import { stylesheet } from 'typestyle';
import {
  flexRoot,
  horizontal,
  wrap,
  layerParent,
  vertical,
  center,
  centerCenter
} from 'csstips';

import { regularGrayText } from '@styles/general';
import { blueButton } from '@styles/buttons';

// Breakpoints (min/max):
// 0/679    - Single vertical column (details above images, cut/color/clarity below specs)
// 0/439    - Full width "Choose" button
// 680/1009  - Two columns (cut/color/clarity below details/choose button)
// 680/829  - Full width "Choose" button
// 1010/~    - Three columns (details left of images, cut/color/clarity below details/choose button)
// 1010/1007 - Full width "Choose" button

export default stylesheet({
  container: {
    ...flexRoot,
    ...horizontal,
    ...wrap,
    ...layerParent,

    padding: 25,

    '@media (max-width: 679px)': {
      display: 'block'
    }
  },
  loading: {
    ...flexRoot,
    ...vertical,
    ...centerCenter,

    height: 300,
    width: '100%',

    p: {
      marginTop: '1em'
    }
  },
  leftAndMiddle: {
    ...flexRoot,
    ...horizontal,

    width: 570,

    '@media (max-width: 679px)': {
      marginTop: 40,
      order: 1,
      width: '100%'
    },

    '@media (min-width: 680px) and (max-width: 1009px)': {
      width: '50%'
    },

    '@media (max-width: 1009px)': {
      ...vertical,
      ...center
    }
  },
  left: {
    order: 0,
    width: 285,
    paddingRight: 20,

    '@media (max-width: 679px)': {
      paddingRight: 0,
      width: '100%'
    },

    '@media (max-width: 1009px)': {
      marginTop: 40,
      order: 1
    },

    $nest: {
      '.product-detail--container.diamond &': {
        '@media (max-width: 1009px)': {
          display: 'none'
        }
      }
    },

    '@media (min-width: 1010px)': {
      width: 275,
      paddingRight: 28
    }
  },
  middle: {
    ...vertical,

    width: 285,

    '@media (max-width: 679px)': {
      paddingRight: 0,
      width: '100%'
    },

    '@media (max-width: 1009px)': {
      order: 0
    },

    $nest: {
      '& .specifications': {
        marginTop: 40
      }
    }
  },
  right: {
    width: 'calc(100% - 570px)',
    padding: '0 0 0 20px',
    fontSize: 15,
    color: '#595959',

    '@media (max-width: 679px)': {
      order: 0,
      width: '100%',
      paddingLeft: 0
    },

    '@media (min-width: 680px) and (max-width: 1009px)': {
      width: '50%'
    }
  },

  singleColumn: {
    $nest: {
      '& .specifications': {
        marginTop: 40
      },

      // specs are nested on combo PD page
      '& .specifications .specifications': {
        marginTop: 0
      }
    }
  },
  description: {
    position: 'relative',
    margin: '10px 0',
    lineHeight: '22px',
    fontSize: 14,
    color: regularGrayText
  },
  stoneSizeSlider: {
    marginTop: 23,
    marginBottom: 20
  },
  shippingAndActions: {
    ...flexRoot,

    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    paddingBottom: 10,
    paddingTop: 10,

    '@media (max-width: 679px)': {
      marginTop: 40
    },

    $nest: {
      '.product-detail--container.combo-ring &, .product-detail--container.band &': {
        ...vertical
      },

      '.product-detail--container.engagement-ring &, .product-detail--container.band &': {
        '@media only screen and (max-width: 679px)': {
          ...vertical,

          borderTop: 'none',
          borderBottom: 'none',
          marginTop: 0,
          marginBottom: 3
        }
      },

      '.product-detail--container.engagement-ring &': {
        '@media only screen and (min-width: 680px) and (max-width: 820px)': {
          ...vertical
        }
      }
    }
  },
  actionsContainer: {
    marginLeft: 20,
    textAlign: 'center',

    $nest: {
      '.product-detail--container.engagement-ring &': {
        '@media only screen and (max-width: 820px)': {
          marginLeft: 0
        }
      },
      '.product-detail--container.combo-ring &, .product-detail--container.band &': {
        ...flexRoot,

        marginLeft: 0,

        '@media only screen and (min-width: 100px) and (max-width: 470px)': {
          ...vertical
        },

        '@media only screen and (min-width: 680px) and (max-width: 830px)': {
          ...vertical
        },

        '@media only screen and (min-width: 1010px) and (max-width: 1024px)': {
          ...vertical
        }
      }
    }
  },
  backToSearch: {
    color: '#908f8f',
    fontSize: 13,
    lineHeight: '22px',
    marginTop: 3
  },
  chooseButton: {
    ...blueButton,
    display: 'block',
    whiteSpace: 'nowrap',

    $nest: {
      ...blueButton.$nest,
      '.product-detail--container.engagement-ring &': {
        '@media only screen and (max-width: 820px)': {
          width: '100%'
        }
      }
    }
  }
});
